/**
 * author: 582196894@qq.com
 * desc: 兼容模式storage
 */

let tuhuSessionStorage = {}

let tuhuLocalStorage = {}

export default {
  /** 兼容无痕模式下sessionStorage */
  sessionStorage: {
    setItem(key, value) {
      try {
        sessionStorage.setItem(key, value)
      } catch (e) {
        tuhuSessionStorage[key] = value
      }
    },
    getItem(key) {
      try {
        const storageVal = sessionStorage.getItem(key) || tuhuSessionStorage[key]
        return storageVal === undefined ? null : storageVal
      } catch (e) {
        return tuhuSessionStorage[key]
      }
    },
    removeItem(key) {
      try {
        sessionStorage.removeItem(key)
      } catch (e) {
        delete tuhuSessionStorage[key]
      }
    },
    clear() {
      try {
        sessionStorage.clear()
      } catch (e) {
        tuhuSessionStorage = {}
      }
    }
  },

  /** 兼容无痕模式下localStorage */
  localStorage: {
    setItem(key, value) {
      try {
        localStorage.setItem(key, value)
      } catch (e) {
        tuhuLocalStorage[key] = value
      }
    },
    getItem(key) {
      try {
        const localStorageVal = localStorage.getItem(key) || tuhuLocalStorage[key]
        return localStorageVal === undefined ? null : localStorageVal
      } catch (e) {
        return tuhuLocalStorage[key]
      }
    },
    removeItem(key) {
      try {
        localStorage.removeItem(key)
      } catch (e) {
        delete tuhuLocalStorage[key]
      }
    },
    clear() {
      try {
        localStorage.clear()
      } catch (e) {
        tuhuLocalStorage = {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./lib/commons/storage.js